import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

const DatePickerNew = ({ input, setDate, value, name }) => {
  const actualValue = input ? input.value : value;
  const actualName = input ? input.name : name;

  // Crucial: Only parse if actualValue is a truthy non-empty string/object.
  // This prevents dayjs(undefined) or dayjs("") from falling back to today's date!
  const parsedDate = actualValue ? dayjs(actualValue) : null;

  const handleDateChange = (newDate) => {
    const formattedDate = newDate && dayjs(newDate).isValid() ? dayjs(newDate).format('YYYY-MM-DD') : null;
    
    if (input && input.onChange) {
      input.onChange(formattedDate);
    }
    if (setDate) {
      setDate(formattedDate); // Pass string to parent state
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker
          value={parsedDate && parsedDate.isValid() ? parsedDate : null}
          onChange={handleDateChange}
          name={actualName}
          renderInput={(params) => <TextField {...params} />}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default DatePickerNew;
